export default __webpack_public_path__ + "static/media/Hyrkanian Resplendent Sun-Strider.b923a7c5.jpg";